module.exports = __webpack_public_path__ + "static/img/MK.a60548ae.png";